"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  en: {
    days: 'Days',
    day: 'Day',
    hours: 'Hours',
    hour: 'Hour',
    minutes: 'Minutes',
    minute: 'Minute',
    seconds: 'Seconds',
    second: 'Second'
  },
  fr: {
    days: 'Jours',
    day: 'Jour',
    hours: 'Heures',
    hour: 'Heure',
    minutes: 'Minutes',
    minute: 'Minute',
    seconds: 'Secondes',
    second: 'Seconde'
  }
};